import { Button, Icon } from "@stellar/design-system";
import { useNavigate } from "react-router-dom";
import { PausedActionTooltip } from "@/components/PausedActionTooltip";
import { ShowForRoles } from "@/components/ShowForRoles";
import { Routes } from "@/constants/settings";
import { useCircleAccount } from "@/hooks/useCircleAccount";
import { useCoSigningPause } from "@/hooks/useCoSigningPause";

export const NewDisbursementButton = () => {
  const navigate = useNavigate();
  const { isCircleAccount, isCircleAccountPending } = useCircleAccount();
  const { isPaused } = useCoSigningPause();

  const goToNewDisbursement = () => {
    navigate(Routes.DISBURSEMENT_NEW);
  };

  const inactiveCircleAccount = isCircleAccount && isCircleAccountPending;
  const disableMessage = inactiveCircleAccount ? "Circle Account is not active" : "";

  return (
    <ShowForRoles acceptedRoles={["owner", "financial_controller", "initiator"]}>
      <PausedActionTooltip isPaused={isPaused}>
        <Button
          variant="primary"
          size="md"
          icon={<Icon.Plus />}
          iconPosition="right"
          onClick={goToNewDisbursement}
          disabled={inactiveCircleAccount || isPaused}
          title={isPaused ? undefined : disableMessage}
        >
          New disbursement
        </Button>
      </PausedActionTooltip>
    </ShowForRoles>
  );
};
